import styled from 'styled-components'
import IMAGES from '../../images'

export const FloatBannerWrapper = styled.div`
    position: relative;
    background: url(${IMAGES.CIRCLE_BG}) center center no-repeat;
    background-size: cover;
    min-height: ${props => props.minHeight || '200px'};
    @media only screen and (max-width: 1600px) {
        min-height: 200px;
    }
    @media only screen and (max-width: 992px) {
        min-height: 180px;
    }
    @media only screen and (max-width: 767px) {
        padding-top: 24px;
    }
`
export const ValueForCustomer = styled.div`
  position: absolute;
  left: 0;
  top: -80px;
  width: 100%;
  display: flex;
  justify-content: space-around;  
  gap: 16px;
  
  @media only screen and (max-width: 768px) {
    justify-content: center;
    gap: 24px;
    top: -62px;
  }
  @media only screen and (max-width: 767px) {
    position: static;
    flex-wrap: wrap;
    justify-content: center;
    padding: 16px;
  }
`
export const ValueItem = styled.div`
    width: 320px;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
    @media only screen and (max-width: 992px) {
        width: 180px;
        font-size: 13px;
    }
    @media only screen and (max-width: 768px) {
        width: 100%;
        font-size: 13px;    
    }
    @media only screen and (max-width: 767px) {
        width: 85%;
        font-size: 13px;
        position: relative;
    }
`
export const ValueItemIcon = styled.div`
    box-shadow: 7px 9px 11.5px 0px #AAC0EA40;
    background: #FFFFFF;
    padding: 16px;
    border-radius: 8px;
    height: 160px;
    width: 170px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        height: auto;
        object-fit: contain;
    }
    @media only screen and (max-width: 992px) {
        height: 120px;
        width: auto;
        img {
            transform: scale(0.6);
        }
    }
    @media only screen and (max-width: 768px) {
        height: 120px;
        width: auto;
        img {
            transform: scale(0.6);
        }
    }
    @media only screen and (max-width: 767px) {
        width: 100%;
        padding: 8px;
        img {
            position: absolute;
            top: 50%;
            left: -28px;
            transform: translateY(-50%);
            height: 64px;
            background: #fff;
            border-radius: 50%;
            padding: 4px;
        }
    }
   
`
export const ValueItemDesc = styled.div`
    color: #575757;
    margin-top: 16px;
    text-align: center;
    box-sizing: border-box;
    word-wrap: break-word;
    overflow-wrap: break-word;
    @media only screen and (max-width: 768px) {
        font-size: 12px;
    }
    @media only screen and (max-width: 767px) {
        display: none;
    }
`
export const ValueItemDescMobile = styled.div`
    display: none;
    @media only screen and (max-width: 767px) {
        display: block;
        padding-left: 28px;
    }
`
export const BannerDescMobile = styled.div`
  display: none;

  @media only screen and (max-width: 767px) {
    display: block;
    font-size: 18px;
    text-align: justify;
    font-weight: 400;
    box-shadow: rgba(0, 0, 0, 0.35) 7px 4px 6px -3px;
    background: rgb(242, 242, 242);
    margin: 0 24px 8px 24px;
    padding: 16px;
  }
`